export const defaultOptions = {
  query: {
    errorPolicy: 'all'
  }
};
